import React, { useEffect, useRef, useState } from 'react';

import { Card, Button, Modal } from 'react-bootstrap';
import { useAuth } from '../../../Auth';
import { useAxios } from '../../../AxiosHandler';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Events.scss';
import PageTable from '../../Shared/PageTable/PageTable';

import moment from "moment";
import DateFormatter from '../../Shared/DateFormatter/DateFormatter';
import FilterSelector from '../../Shared/FilterSelector/FilterSelector';
import SMSSender from '../../Shared/SMSSender/SMSSender';

import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from "@fullcalendar/interaction";

import { useHistory } from "react-router-dom";
import Field from '../../Shared/Wizard/Field/Field';

function Events() {
    const auth = useAuth();
    const t = useTranslate();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    const history = useHistory();

    const calendarRef = useRef(null);

    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });

    const notifyWarning = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "warning-toast"
    });

    const [deleteEvent, setDeleteEvent] = useState({
        name: "",
        EventType: "",
        location: "",
        description: "",
        headCount: "",
        periods: [""],
        capacity: "",
        maintenance: [""]
    })

    const [allEvents, setAllEvents] = useState<Array<Object>>([]);
    const [allResources, setAllResources] = useState<Array<Object>>([]);
    const [holidays, setHolidays] = useState<Array<Object>>([]);
    const [allBookings, setAllBookings] = useState<Array<Object>>([]);

    const [participantsEventId, setParticipantsEventId] = useState("");
    const [selectedItems, setSelectedItems] = useState<any>([]);
    const [showSMSSendModal, setShowSMSSendModal,] = useState(false);

    const [eventsFilter, setEventsFilter] = useState([]);

    const [importEvents, setImportEvents] = useState<Array<Object>>([]);
    const [importedEventIds, setImportedEventIds] = useState<Array<string>>([]);
    const [importEventIds, setImportEventIds] = useState<Array<string>>([]);
    const [importing, setImporting] = useState(false);
    const [loadingImportList, setLoadingImportList] = useState(false);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showImportModal, setShowImportModal] = useState(false);
    const [showParticipantsModal, setShowParticipantsModal] = useState(false);

    const [updateTable, setUpdateTable] = useState(0);

    const handleShowNewEvent = () => {
        history.push("/event");
    };

    const handleShowImportEvent = () => {
        getEventsImportList();
        setShowImportModal(true);
    };

    const handleShowSMSSendModal = () => { setShowSMSSendModal(true); };
    const handleShowParticipantsModal = (dataLine, evt) => {
        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();
        setParticipantsEventId(dataLine._id);
        setShowParticipantsModal(true);
    }
    const handleCloseParticipantsModal = () => setShowParticipantsModal(false);

    const handleShowDeleteModal = (dataLine, evt) => {
        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();

        let hasReservedResources:any = [];
        allResources.forEach(resource=> {
            let foundAttachedResource = resource["bookings"].find(booking => booking["eventId"].find(id => id== dataLine["_id"]));
            let isReserved = resource["bookings"].find(booking => booking["eventId"].find(id => id == dataLine["_id"]) && booking["bookingtimes"].length != 0);
            if(isReserved != undefined){
                hasReservedResources.push(foundAttachedResource);
            }
        });

        if(hasReservedResources.length != 0) {
            notifyWarning(t("booking.toast_resourcesexist")); 
            return undefined;
        }
        setDeleteEvent(dataLine);
        setShowDeleteModal(true);
    }

    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    const handleCloseImportModal = () => {
        setShowImportModal(false);
        setImportEventIds([]);
        setImportEvents([]);
        setImportedEventIds([]);
    };

    function handleImport() {
        setImporting(true);
        axios.post(
            "/api/events/import/byids",
            {
                importEventIds: importEventIds
            },
            {
                headers: { 'x-access-token': auth.user["token"] }
            }
        ).then(res => {
            setImportedEventIds([...importedEventIds, ...res.data]);
            setImporting(false);
            setImportEventIds([]);
            fetchData();
            setUpdateTable(updateTable + 1);
        });
    };

    function getEventsImportList() {
        setLoadingImportList(true);
        axios.post(
            "/api/events/import/list",
            {},
            {
                headers: { 'x-access-token': auth.user["token"] }
            }
        ).then(res => {
            setImportEvents(res.data);
            setLoadingImportList(false);
        }).catch(err => {
            setLoadingImportList(false);
        });
    };

    function handleDeleteEvent() {
        axios.delete(
            "/api/events/" + deleteEvent["_id"],
            {},
            {
                headers: { 'x-access-token': auth.user["token"] }
            }
        ).then(res => {
            notifySuccess(t("events.toast_Events_deleted"));
            handleCloseDeleteModal();
            setUpdateTable(updateTable + 1);
            fetchData();
        });
    };

    const handleSendSMS = (selectedIds) => {
        setSelectedItems(selectedIds);
        handleShowSMSSendModal();
    }

    function fetchData() {
        axios.all([
            axios.single({
                method: "get",
                url: "/api/events",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            axios.single({
                method: "get",
                url: "/api/resources",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            axios.single({
                method: "get",
                url: "/api/bookings",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            
        ])
        .then(axios.spread((...res) => {
            setAllEvents(res[0]["data"]);
            setAllResources(res[1]["data"]);
            setAllBookings(res[2]["data"]);
        }))
        .catch(err => console.log(err));
    }

    function getHolidays() {
        axios.single({
            method: "get",
            url: "https://webapi.no/api/v1/holidays/2021",
            responseType: "json",
            headers: {'x-access-token': auth.user["token"]}
        })
        .then((res) => {
           setHolidays(res.data.data);
        })
        .catch(err => console.log(err));
    }

    function lightOrDark(color) {

        // Variables for red, green, blue values
        var r, g, b, hsp;
        
        // If hex --> Convert it to RGB: http://gist.github.com/983661
        color = +("0x" + color.slice(1).replace( 
        color.length < 5 && /./g, '$&$&'));

        r = color >> 16;
        g = (color >> 8) & 255;
        b = color & 255;
        
        // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
        hsp = Math.sqrt(
        0.299 * (r * r) +
        0.587 * (g * g) +
        0.114 * (b * b)
        );
    
        // Using the HSP value, determine whether the color is light or dark
        if (hsp>127.5) {
            return 'light';
        } 
        else {
            return 'dark';
        }
    }

    function getEventParticipants(event) {
        let participants = 0;
        allBookings.forEach(booking => {
            if(booking["events"] != undefined && booking["events"].map(event => event._id).includes(event._id)){
                participants += booking["guests"].length;
            }
        });
        return participants;
    }

    useEffect(() => {
        if (auth.user["userdata"] == undefined) { window.location.href = "/login"; }
        fetchData();
        getHolidays();
    }, []);

    return (
        <>
            <div className="maincontent">
                <div className="Events-container">
                    <Card>
                        <Card.Body>
                            <h4 className="header-title">{t("events.title")}</h4>
                            <FullCalendar
                                ref={calendarRef}
                                plugins={[dayGridPlugin, interactionPlugin]}
                                initialView="dayGridMonth"
                                schedulerLicenseKey="0022145730-fcs-1611561300"
                                locale="nb"
                                firstDay={1}
                                height={"800px"}
                                themeSystem="bootstrap"
                                events={[
                                    ...holidays.map(h => {
                                        return {
                                            id: "",
                                            title: h["description"],
                                            start: h["date"],
                                            display: "background",
                                            allDay: true,
                                            backgroundColor: "#ffa3a3",
                                            borderColor: "#ffa3a3",
                                            textColor: "black"
                                        }
                                    }),
                                    ...[].concat.apply([], (allEvents.map(e => [...e["periods"].map(p => {
                                        return {
                                            id: "",
                                            title: e["name"],
                                            start: moment(p.from).toDate(),
                                            end: moment(p.to).add(1, "day").toDate(),
                                            properevent: e,
                                            allDay: true,
                                            backgroundColor: e["color"] != undefined ? e["color"] : "#fcb85f",
                                            borderColor: e["color"] != undefined ? e["color"] : "#fcb85f",
                                            textColor: e["color"] != undefined && lightOrDark(e["color"]) == "dark" ? "white" : "black"
                                        }
                                    })]) as Array<any>))
                                ]}
                                eventClick={(evt) => {
                                    let foundEvent = (evt as any).event._def.extendedProps.properevent;
                                    if (foundEvent != undefined) {
                                        history.push("/event/" + foundEvent._id)
                                    }
                                }}
                            />
                            
                            <hr/>

                            {auth.user["userdata"]["role"][0] === "Admin" &&
                                <React.Fragment>
                                    <Button className="newEventBtn" onClick={handleShowNewEvent}>{t("events.new")}</Button>
                                    <Button className="newEventBtn" onClick={handleShowImportEvent}>{t("events.import_btn")}</Button>
                                </React.Fragment>
                            }
                            <br />

                            <p>{t("events.filters.title")}</p>
                            <FilterSelector
                                filtersUrl="/api/filters/bytype/"
                                filterType="event"
                                fields={[
                                    { label: t("events.name"), value: "name", type: "string" },
                                    { label: t("events.from"), value: "fromDate", type: "date" },
                                    { label: t("events.to"), value: "toDate", type: "date" },
                                ]}
                                onChange={(filter) => {
                                    setEventsFilter(filter.filters);
                                }}
                                onAddClick={() => {

                                }}
                                onEditClick={ auth.user["userdata"]["role"][0] === "Admin" ? () => {} : undefined}
                                onDeleteClick={() => {

                                }}
                                addFilterText={t("general.addfilter")}
                            ></FilterSelector>
                            <PageTable
                                dataUrl={"/api/events/getAllPaged/"}
                                defaultSortField="fromDate"
                                defaultSortDirection="asc"
                                options={{
                                    showFields: [
                                        { label: t("events.name"), field: "name" },
                                        {
                                            label: t("events.from"),
                                            field: "fromDate",
                                            override: (dataLine) => dataLine.fromDate != undefined ? <DateFormatter date={dataLine.fromDate} /> : ""
                                        },
                                        {
                                            label: t("events.to"),
                                            field: "toDate",
                                            override: (dataLine) => dataLine.toDate != undefined ? <DateFormatter date={dataLine.toDate} /> : ""
                                        },
                                        {
                                            label: t("events.headCount"),
                                            field:  "maximumHeadcount",
                                            noFilter: "",
                                            override: (dataLine) => getEventParticipants(dataLine) + "/" + (dataLine.maximumHeadcount != undefined ? dataLine.maximumHeadcount : t("events.undefined_Headcount")),
                                            
                                        },
                                    ]
                                }}
                                dataBefore={(dataLine) =>
                                    <div className="colordisplay" style={{ backgroundColor: dataLine["color"] }}></div>
                                }
                                dataAfter={(dataLine) =>
                                    <div>
                                        <Button
                                            onClick={(evt) => handleShowParticipantsModal(dataLine, evt)}
                                            style={{
                                                marginBottom: "10px"
                                            }}
                                        >
                                            {t("events.participants.btn")}
                                        </Button>
                                        
                                        {auth.user["userdata"]["role"] == "Admin" ?
                                            <Button
                                                onClick={(evt) => handleShowDeleteModal(dataLine, evt)}
                                                style={{
                                                    marginBottom: "10px",
                                                    marginLeft: "10px"
                                                }}
                                            >{t("events.delete")}</Button>
                                        : null}
                                    </div>
                                }
                                onLineClick={(dataLine) => dataLine["accessRule"] != "adminprivate" ? history.push("/event/" + dataLine["_id"]) : null}
                                hidePagination={false}
                                hidePagesize={false}
                                hideFilter={false}
                                updateTable={updateTable}
                                hover={true}
                                permaFilters={eventsFilter}
                            />
                        </Card.Body>
                    </Card>
                </div>
            </div>

            {/* Import Modal */}
            <Modal show={showImportModal} className="eventimportmodal" size="xl" onHide={handleCloseImportModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("events.import_modal.title")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p dangerouslySetInnerHTML={{__html: t("events.import_modal.text").split("\n").join("<br/>")}}></p>
                    <div className="importarea">
                        { loadingImportList ?
                            <p className="loadingtext">{t("events.import_modal.loading")}</p>
                        : null}
                        { !loadingImportList && importEvents.length < 1 ?
                            <p className="loadingtext">{t("events.import_modal.nonefound")}</p>
                        : null}
                        {importEvents.length > 0 ?
                            <table className={"table table-striped table-sm " + (!importing ? "table-hover" : "table-locked")}>
                                <thead>
                                    <tr>
                                        <th>{t("events.import_modal.table.import")}</th>
                                        <th>{t("events.import_modal.table.name")}</th>
                                        <th>{t("events.import_modal.table.from")}</th>
                                        <th>{t("events.import_modal.table.to")}</th>
                                        <th>{t("events.import_modal.table.participants")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {importEvents.map((e, i) => {
                                        return <tr className={importedEventIds.includes(e["id"]) ? "imported" : ""} key={i} onClick={() => {
                                            if (!importing && !importedEventIds.includes(e["id"])) {
                                                if (importEventIds.indexOf(e["id"]) == -1) {
                                                    setImportEventIds([...importEventIds, e["id"]]);
                                                } else {
                                                    setImportEventIds(importEventIds.filter(id => id != e["id"]));
                                                }
                                            }
                                        }}>
                                            <td>
                                                <Field
                                                    type="checkbox"
                                                    value={importEventIds.includes(e["id"])}
                                                ></Field>
                                            </td>
                                            <td>{e["name"]}</td>
                                            <td>{e["fromDate"]}</td>
                                            <td>{e["toDate"]}</td>
                                            <td>{e["participants"].length}</td>
                                        </tr>
                                    })}
                                </tbody>
                            </table>
                        : null}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleCloseImportModal}>
                        {t("events.import_modal.close")}
                    </Button>
                    <Button onClick={handleImport} disabled={(importEventIds.length < 1) || importing}>
                        { importEventIds.length > 0 ?
                            importing ?
                                t("events.import_modal.importing")
                            : 
                                t("events.import_modal.import_start") + " " + importEventIds.length + " " + t("events.import_modal.import_end")
                        : t("events.import_modal.import_none")}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Delete Modal */}
            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("events.delete_Event")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{t("events.delete_info")}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleCloseDeleteModal}>
                        {t("events.cancel")}
                    </Button>
                    <Button onClick={handleDeleteEvent}>
                        {t("events.delete_Event")}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Participants Modal */}
            <Modal show={showParticipantsModal} size="xl" onHide={handleCloseParticipantsModal} >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("events.participants.title")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{t("events.participants.info")}</p>
                    <PageTable
                        dataUrl={"/api/events/participants/getAllPaged/byid/" + participantsEventId}
                        checkAllUrl={"/api/events/participants/getAllPaged/byid/checkAll/" + participantsEventId}
                        allDataUrl={"/api/events/participants/byid/checkAll/" + participantsEventId}
                        selectedFunctions={[
                            { label: "SendSMS", func: (selectedIds) => { handleSendSMS(selectedIds); } },
                        ]}
                        options={{
                            showFields: [
                                { label: t("events.participants.lastname"), field: "lastname" },
                                { label: t("events.participants.firstname"), field: "firstname" },
                                { label: t("events.participants.organization"), field: "organization" },
                                { label: t("events.participants.phone"), field: "phone" },
                                { label: t("events.participants.email"), field: "email" },
                            ]
                        }}
                        hidePagination={false}
                        hidePagesize={false}
                        hideFilter={false}
                        hover={false}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleCloseParticipantsModal}>
                        {t("events.close")}
                    </Button>
                </Modal.Footer>
            </Modal>
            <SMSSender
                show={showSMSSendModal}
                onHide={() => setShowSMSSendModal(false)}
                onCancel={() => setShowSMSSendModal(false)}
                recipients={selectedItems.map(i => { return { number: i.phone, name: i.lastname + ", " + i.firstname } })}
            ></SMSSender>
        </>
    )
}
export default Events;